import Vue from 'vue';
import Vuex from 'vuex';

import PeriodoController from '../assets/ts/controller/PeriodoController';
import Tempo from '../../bower_components/teknisavuecomponents/components/time/Tempo';
import Time from '../../bower_components/teknisavuecomponents/assets/utils/Time'

import LoginController from '@/assets/ts/controller/LoginController';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';

import { Periodo } from '../../bower_components/teknisavuecomponents/assets/interfaces/interfaces';
import PopupController from '@/assets/ts/controller/PopupController';
import VinculoController from "@/assets/ts/controller/VinculoController";

const actualDate = new Tempo().getData();
const comparableDate = Time.dateStringToDate(actualDate);

declare global {
  interface Window {
    sqlitePlugin: any;
    Connection: any;
    Navigator: any;
  }
}

Vue.use(Vuex);

let popUpSiezes = require('./../assets/json/popUpSizes.json');

const store = new Vuex.Store({
  state: {
    projectName: 'Portal do Gestor',
    isAccessTokenValid: false,
    userData: {},
    sizes: {
      popUp: {}
    },
    loginAlert: {
      message: '',
      type: 'success',
      show: false,
    },
    periodoIsOpen: false,
    dtIniApuracao: '',
    dtFimApuracao: '',
    canUserEditCurrentPeriodo: false,
    user: {
      name: '',
      id: '',
      email: null,
      team: '',
      shift: '',
      nrvinculom: null,
      nrtipovinculom: null,
      cdoperador: null,
      nmoperador: null,
      nrorg: null,
      dp: null,
      nrestrutlegal: null,
      nrestrutgeren: null,
      idalterptovinculo: null,
      idaprovocorrencia: null,
      idaltresumofreq: null,
      idtrocahorario: null,
      idconfirmrecsenport: null,
      idrealizaadmissao: null,
      idrealizacadautom: null,
      iddpalterptovinculo: null,
      nrparcnegocio: null,
      idpgrestringeregist: null,
      idbloqueioedicaomarc: null,
      idexigefotoregpntpg: null,
      idpgrestringetelaregist: null,
      nrtpestrutlegal: null,
      nrtpestrutgeren: null,
      idativacontroleacesso: null,
      idoperadorsst: null,
    },
    permissoes: [],
    currentView: '',
    productVersion: '0.0',
    views: [],
    options: [
      {
        nome: 'Alterar Senha',
        action: () => PopupController.openChangePasswordPopUp(),
      },
      {
        nome: 'Controle de Acesso',
        action: () => {
          import('../Router').then((module) => {
            const router = module.default;
            router.push({ path: '/controleAcesso' });
          });
        },
      },
      {
        nome: 'Sair',
        action: () => LoginController.logout(),
      },
    ],
    loadingVisibility: false,
    loadingIsForceHidden: false,
    loadingProgressPercentage: 0,
    loadingIsIndeterminate: true,
    loadingAppendedText: '',
    loadingCancelVisible: false,
    periodosDemonstrativo: [],
    periodoDemonstrativoAtual: {} as Periodo,
    estruturasGerenciais: [],
    estruturaGerencialAtual: undefined,
    finishedLoadingInfo: false,
    notifications: {
      messages: [],
      read: false,
    },
    intervalRPUReloadId: null,
    solicitacao: {
      NRSOLICITACAO: null,
      NRTIPOSOLICITACAO: null,
      NRVINCULOM: null,
    },
    offline: {
      loadingSincronizacao: false,
      loadingLimpezaCache: false,
      reloadCache: 0
    },
    isOffline: false,

    // PopUps
    popUp: {
      popUps: [
        {
          name: 'changePassword',
          isVisible: false,
          component: 'ChangePassword',
          data: {},
        },
        {
          name: 'resetPassword',
          isVisible: false,
          component: 'ResetPassword',
          data: {},
        },
        {
          name: 'confirmPassword',
          isVisible: false,
          isNotClosePopup: false,
          component: 'ConfirmPassword',
          data: {},
        },
        {
          name: 'confirmationChangePassword',
          isVisible: false,
          component: 'ConfirmationChangePassword',
          data: {},
        },
        {
          name: 'detalhesQuadroGeral',
          isVisible: false,
          component: 'DetalhesQuadroGeral',
          maxWidth: popUpSiezes.extraLarge,
          data: {},
        },
        {
          name: 'detalhesSolicitacao',
          isVisible: false,
          component: 'DetalhesSolicitacao',
          maxWidth: popUpSiezes.extraLarge,
          data: {},
        },
      ],
    },
  },
  getters: {
    viewName: (state) => state.currentView,
    projectName: (state) => state.projectName,
    user: (state) => state.user,
    userData: (state) => state.userData,
    permissoes: (state) => state.permissoes,
    loginAlert: (state) => state.loginAlert,
    views: (state) => state.views,
    options: (state) => state.options,
    loadingVisibility: (state) => state.loadingVisibility,
    loadingIsForceHidden: (state) => state.loadingIsForceHidden,
    loadingProgressPercentage: (state) => state.loadingProgressPercentage,
    loadingIsIndeterminate: (state) => state.loadingIsIndeterminate,
    loadingAppendedText: (state) => state.loadingAppendedText,
    loadingCancelVisible: (state) => state.loadingCancelVisible,
    periodosDemonstrativo: (state) => state.periodosDemonstrativo,
    productVersion : (state) => state.productVersion,
    periodoDemonstrativoAtual: (state) => state.periodoDemonstrativoAtual,
    getNrperiodoApuracaoAtual: (state) => (state.periodoDemonstrativoAtual as Periodo).NRPERIODOAPURACAO,
    estruturasGerenciais: (state) => state.estruturasGerenciais,
    estruturaGerencialAtual: (state) => state.estruturaGerencialAtual,
    finishedLoadingInfo: (state) => state.finishedLoadingInfo,
    notifications: (state) => state.notifications,
    periodoIsOpen: (state) => state.periodoIsOpen,
    canUserEditCurrentPeriodo: (state) => state.canUserEditCurrentPeriodo,
    popUps: (state) => state.popUp.popUps,
    popUpConfirmPassword: (state) => state.popUp.popUps.find((popUp) => popUp.name == 'confirmPassword'),
    popUpSize: (state) => state.sizes.popUp,
    intervalRPUReloadId: (state) => state.intervalRPUReloadId,
    solicitacao: (state) => state.solicitacao,
    offline: (state) => state.offline,
    isOffline: (state) => state.isOffline,
  },
  mutations: {
    changeCurrentView(state, payload) {
      state.currentView = payload;
    },
    setLoadingVisibility(state, payload) {
      state.loadingVisibility = payload;
    },
    setLoadingIsForceHidden(state, payload) {
      state.loadingIsForceHidden = payload;
    },
    setLoadingProgressPercentage(state, payload) {
      state.loadingProgressPercentage = payload;
    },
    setLoadingIsIndeterminate(state, payload) {
      state.loadingIsIndeterminate = payload;
    },
    setLoadingAppendedText(state, payload) {
      state.loadingAppendedText = payload;
    },
    setLoadingCancelVisible(state, payload) {
      state.loadingCancelVisible = payload;
    },
    updateUserData(state, payload) {
      state.userData = payload;
    },
    updateUser(state, payload) {
      state.user = payload;
    },
    updatePermissoes(state, payload) {
      state.permissoes = payload;
    },
    updateLoginAlert(state, payload) {
      state.loginAlert = payload;
    },
    updatePeriodosDemonstrativo(state, payload) {
      // Adiciona os periodos
      state.periodosDemonstrativo = payload.map((periodo: any) => ({
        text: periodo.DSPERIODOAPURACAO,
        value: periodo.NRPERIODOAPURACAO,
        ...periodo,
      }));

      const periodoAtual = PeriodoController.getPeriodoAtual(comparableDate, state.periodosDemonstrativo);

      state.periodoDemonstrativoAtual = periodoAtual || state.periodosDemonstrativo[0];
    },
    updateProductVersion(state, payload) {
      state.productVersion = payload;
    },
    updatePeriodoDemonstrativoAtual(state, payload) {
      state.periodoDemonstrativoAtual = payload;
    },
    updateEstruturasGerenciais(state, payload) {
      state.estruturasGerenciais = payload.map(estrutura => ({
        text: estrutura.NMESTRUTURA,
        value: estrutura.NRESTRUTURAM,
        NMESTRUTURA: estrutura.NMESTRUTURA,
        NRESTRUTURAM: estrutura.NRESTRUTURAM,
        IDTIPOESTRUTURA: estrutura.IDTIPOESTRUTURA,
        NRTIPOESTRUTURA: estrutura.NRTIPOESTRUTURA,
      }));

      const estruturaAtual = state.estruturasGerenciais[0];
      state.estruturaGerencialAtual = estruturaAtual;
    },
    updateEstruturaGerencialAtual(state, payload) {
      state.estruturaGerencialAtual = payload;
    },
    updateFinishedLoadingInfo(state, payload) {
      state.finishedLoadingInfo = payload;
    },
    updateViews(state, payload) {
      state.views = payload;
    },
    updateNotifications(state, payload) {
      state.notifications.messages = payload;
      state.notifications.read = false;
    },
    setNotificationsAsRead(state) {
      state.notifications.read = true;
    },
    setRestringeRegistro(state) {
      state.user.idpgrestringeregist = true;
    },
    unsetRestringeRegistro(state) {
      state.user.idpgrestringeregist = false;
    },
    controlPopUp(state, payload: { [key: string]: any, popUp: string }) {
      const popUp: any = state.popUp.popUps.find((item) => item.name === payload.popUp);
      if (!popUp) {
        return false;
      }

      const keys = Object.keys(payload);
      for (const key of keys) {
        popUp[key] = payload[key];
      }
    },
    setIntervalRPUReloadId(state, payload) {
      state.intervalRPUReloadId = payload;
    },
    setSolicitacao(state, payload) {
      state.solicitacao = payload;
    },
    updateOffline(state, payload) {
      state.offline = payload;
    },
    setIsOffline(state, payload) {
      state.isOffline = payload;
    },
  }
});

// Inclui padrões de tamanho
store.state.sizes.popUp = popUpSiezes;

// Watching For Changes

// Periodo Atual onChange
store.watch(() => store.state.periodoDemonstrativoAtual, (newValue: any) => {
  const user = store.getters.user;
  const isUserDP = user.dp;
  const periodoIsOpen = newValue.IDPERIODOAPURACAO === 'ABERTO';
  const dtIniApuracao = newValue.DTINICIALAPURACAO;
  const dtFimApuracao = newValue.DTFINALAPURACAO;

  // Operador será capaz de realizar alterações sistêmicas caso:
  // - Tenha perfil "Administrador" ou;
  // - Não tenha perfil "Administrador" porém o período está "ABERTO" e o parâmetro da organizacao IDALTERPTOVINCULO está como "S".
  const userAlteraPeriodosAnteriores =
    (isUserDP && user.iddpalterptovinculo) ||
    (!isUserDP && periodoIsOpen && user.idalterptovinculo === 'S');

  store.state.periodoIsOpen = periodoIsOpen;
  store.state.canUserEditCurrentPeriodo = userAlteraPeriodosAnteriores;
  store.state.dtIniApuracao = dtIniApuracao;
  store.state.dtFimApuracao = dtFimApuracao;
});


// User onChange
store.watch(() => store.state.user, (newValue: any) => {
  const user = store.getters.user;
  const isUserDP = user.dp;

  // Verifica se o usuário tem o 'dp' como true
  if (isUserDP) {
    // Verifica se o item 'Controle de Acesso' já não foi adicionado
    const controleDeAcessoExistente = store.state.options.some(option => option.nome === 'Controle de Acesso');
    
    if (!controleDeAcessoExistente) {
      // Se o item não existir, adicione o item ao array de opções
      store.state.options.push({
        nome: 'Controle de Acesso',
        action: () => {
          import('../Router').then((module) => {
            const router = module.default;
            router.push({ path: '/controleAcesso' });
          });
        },
      });
    }
  } else {
    // Caso contrário, remova o item "Controle de Acesso", se ele existir
    store.state.options = store.state.options.filter(option => option.nome !== 'Controle de Acesso');
  }

});
(window as any).store = store;

export default store;
